import { createAutomationTask } from 'services/automation/api';
import { AutomationTaskInput } from 'services/automation/types';

export const createAutomationTasksV2 = async (
  values: AutomationTaskInput[],
  {
    organizationId,
    campaignId
  }: {
    organizationId: string;
    campaignId: string;
  }
) => {
  if (!values?.length) {
    return;
  }

  await Promise.all(
    values.map((task) =>
      createAutomationTask({
        ...task,
        organizationId,
        campaignId
      })
    )
  );
};
